import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { l } from "@unauthenticated/shared/locales/i18n";

import { ErrorBox } from "../ErrorBox";

const UnauthorizedErrorBox: FC = () => {
  const { t } = useTranslation();
  return <ErrorBox error={t(l.signIn.NotAuthorized)} subMessage={t(l.signIn.ContactAPrac)} />;
};

export { UnauthorizedErrorBox };
